// src/pages/estoque/ExcluirEntradaModal.js
import React from 'react';
import Modal from '../../components/modalForm/StackedBootstrapModal';
import { FaTimes, FaTrashAlt } from 'react-icons/fa';
import Input from '../../components/input/Input';

const ExcluirEntradaModal = ({
  show,
  notaId,
  justificativa,
  onChangeJustificativa,
  onClose,
  onConfirm,
  excluindo,
  error,
  possuiAlteracoes,
}) => {
  const quantidadeCaracteres = justificativa.trim().length;
  const justificativaValida = quantidadeCaracteres >= 15 && justificativa.length <= 1000;

  return <Modal show={show} onHide={excluindo ? undefined : onClose} centered backdrop="static">
    <Modal.Header closeButton={!excluindo}>
      <div>
        <Modal.Title>Excluir entrada #{notaId}</Modal.Title>
        <small className="text-muted">Esta operação ficará registrada no histórico da nota.</small>
      </div>
    </Modal.Header>
    <Modal.Body>
      <div className="alert alert-warning">
        O estoque será estornado e os custos vinculados a esta entrada serão removidos. A nota e seus itens continuarão disponíveis na consulta de excluídas.
      </div>
      {possuiAlteracoes && <div className="alert alert-info">
        Existem alterações não salvas. Elas serão descartadas e a exclusão considerará a versão atualmente salva.
      </div>}
      {error && <div className="alert alert-danger">{error}</div>}
      <Input
        label="Justificativa da exclusão *"
        value={justificativa}
        rows={4}
        size="100%"
        maxLength={1000}
        disabled={excluindo}
        onChange={(event) => onChangeJustificativa(event.target.value)}
      />
      <div className={`entrada-exclusao-contador ${quantidadeCaracteres > 0 && quantidadeCaracteres < 15 ? 'invalido' : ''}`}>
        {quantidadeCaracteres}/1000 caracteres — mínimo de 15
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button type="button" className="btn btn-outline-secondary" disabled={excluindo} onClick={onClose}>
        <FaTimes /> Cancelar
      </button>
      <button type="button" className="btn btn-danger" disabled={!justificativaValida || excluindo} onClick={onConfirm}>
        <FaTrashAlt /> {excluindo ? 'Excluindo...' : 'Excluir entrada'}
      </button>
    </Modal.Footer>
  </Modal>;
};

export default ExcluirEntradaModal;
